import { useEffect } from 'react'
import { webLogger } from '@muse-web/logger'
import { loadWithChunkRetry } from '@muse-web/router'

type TDeviceFingerprintTrackerProps = {
    userId: number
}

const loadScheduleDeviceFingerprint = () =>
    import(
        /* webpackChunkName: 'schedule-device-fingerprint' */ '../helpers/device-fingerprint/scheduleDeviceFingerprint'
    )

export const DeviceFingerprintTracker = ({ userId }: TDeviceFingerprintTrackerProps) => {
    useEffect(() => {
        loadWithChunkRetry(loadScheduleDeviceFingerprint)
            .then(({ scheduleDeviceFingerprint }) => {
                scheduleDeviceFingerprint(String(userId))
            })
            .catch((error: unknown) => {
                webLogger.error(error instanceof Error ? error : String(error))
            })
    }, [userId])

    return null
}
